const admin = {
    namespaced: true,
    state: {
        initAdminProjects: false,
        initAdminProjectApproval: false,
        initAdminUsers: false,
    },
    mutations: {
        set_init_flag_projects: (state, trueOrFalse) => {
            state.initAdminProjects = trueOrFalse
        },
        set_init_flag_approval: (state, trueOrFalse) => {
            state.initAdminProjectApproval = trueOrFalse
        },
        set_init_flag_users: (state, trueOrFalse) => {
            state.initAdminUsers = trueOrFalse
        }
    },
    actions: {}
};

export default admin
